import type { FunctionComponent, HTMLProps, ReactNode } from 'react'
import React from 'react'

import classNames from 'classnames'

import type { LinkAppearance } from '../../types'
import styles from '../Button/Button.module.scss'
import { BaseLink } from '../Links'
import { TypographyV2 } from '../Seatbelt2/Foundations/Typography'

export const ButtonLink: FunctionComponent<Props> = ({
  children,
  href = '',
  appearance = 'primary',
  disabled = false,
  className,
  disclaimerText,
  ...rest
}) => {
  const props = {
    href,
    className: classNames(
      styles.button,
      styles[`button-${appearance}`],
      disabled && [styles['button-disabled']],
      className
    ),
    'data-testid': `buttonlink-${appearance}`,
    ...(disabled && { tabIndex: -1, role: 'link', 'aria-disabled': true }),
    ...rest,
  }

  return (
    <>
      <BaseLink {...props}>{children}</BaseLink>

      {disclaimerText && (
        <TypographyV2
          textStyle="sb-text-interface-body-x-small-regular"
          className={styles.disclaimer}
        >
          {disclaimerText}
        </TypographyV2>
      )}
    </>
  )
}

///////// IMPLEMENTATION /////////

type Props = {
  href?: string | null
  appearance?: LinkAppearance
  disabled?: boolean
  className?: string
  disclaimerText?: string
  children?: ReactNode
  [key: `data-${string}`]: string | undefined
} & HTMLProps<HTMLAnchorElement>
